module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "blackBG-grammar"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal"
  }, [(_vm.results) ? _c('div', {
    staticClass: "played-words"
  }, [(_vm.results) ? _c('div', {
    staticClass: "backBtn",
    on: {
      "click": function($event) {
        _vm.results = false
      }
    }
  }, [_c('inline-svg', {
    staticClass: "cup-svg saveWord",
    attrs: {
      "src": require('../../assets/svg/back.svg').default
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.$t("grammarGame.game-summery.improve")))]), _vm._v(" "), (_vm.mistakes.length) ? _c('div', [_c('div', {
    staticClass: "gmistakes-header"
  }, [_c('div', {
    staticClass: "wbold g-head"
  }, [_vm._v("\n            " + _vm._s(_vm.$t("grammarGame.game-summery.question")) + "\n          ")]), _vm._v(" "), _c('div'), _vm._v(" "), _c('div', {
    staticClass: "wbold"
  }, [_vm._v(_vm._s(_vm.$t("grammarGame.game-summery.answer")))]), _vm._v(" "), _c('div', {
    staticClass: "wbold"
  }, [_vm._v("\n            " + _vm._s(_vm.$t("grammarGame.game-summery.mistake")) + "\n          ")])]), _vm._v(" "), _vm._l((_vm.mistakes), function(word, idx) {
    return _c('div', {
      key: idx,
      staticClass: "gmistakes"
    }, [_c('div', {
      staticClass: "audio"
    }, [_c('AudioBtn', {
      attrs: {
        "urlId": word.word.id
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "g-q"
    }, [_vm._v(_vm._s(word.word.eng))]), _vm._v(" "), _c('div', {
      staticClass: "g-a arial"
    }, [_vm._v(_vm._s(word.word.heb))]), _vm._v(" "), _c('div', {
      staticClass: "g-m"
    }, [_vm._v(_vm._s(word.mistake))])])
  })], 2) : _vm._e(), _vm._v(" "), (!_vm.mistakes.length) ? _c('div', {
    staticClass: "divMistakes",
    style: ({
      textAlign: _vm.ltr ? 'left' : 'right'
    })
  }, [_vm._v("\n        " + _vm._s(_vm.$t("grammarGame.game-summery.perfect")) + "\n      ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.results) ? _c('div', [_c('div', {
    staticClass: "description"
  }, [_vm._v(_vm._s(_vm.outText))]), _vm._v(" "), (_vm.audioSrc) ? _c('Spacer', {
    attrs: {
      "height": "12"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.audioSrc) ? _c('AudioPlayer', {
    attrs: {
      "audioSrc": _vm.audioSrc,
      "autoPlay": _vm.isAutoPlay
    }
  }) : _vm._e(), _vm._v(" "), (_vm.vidSrc) ? _c('Spacer', {
    attrs: {
      "height": "12"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.vidSrc) ? _c('VideoPlayer1', {
    attrs: {
      "vidSrc": _vm.makeLinkEmbaddable(_vm.vidSrc)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.imgSrc) ? _c('Spacer', {
    attrs: {
      "height": "12"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.imgSrc) ? _c('img', {
    attrs: {
      "id": "img",
      "src": _vm.imgSrc
    }
  }) : _vm._e(), _vm._v(" "), _c('Spacer', {
    attrs: {
      "height": "12"
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.results) ? _c('div', {
    staticClass: "flex btnsDiv"
  }, [_c('button', {
    staticClass: "btnSummry btnRestart",
    on: {
      "click": _vm.restartGame
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t("grammarGame.game-summery.again")) + "\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "btnSummry btnRes",
    on: {
      "click": function($event) {
        _vm.results = true
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t("grammarGame.game-summery.results")) + "\n      ")])]) : _vm._e(), _vm._v(" "), (!_vm.results) ? _c('button', {
    staticClass: "btnSummry btnGo",
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t("grammarGame.game-summery.continue")) + "\n    ")]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0ae1a49d","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GrammarGame/game-summary.vue
// module id = 418
// module chunks = 1 3